/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf401,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf404,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf500,
} from "../../types/pecegePayBilletController/GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf.ts";

function getGetApiV1PecegepayBilletCoursefinpersonpaymentidPdfUrl(
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams["courseFinPersonPaymentId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/pecegepay/billet/${courseFinPersonPaymentId}/pdf` as const,
  };
  return res;
}

/**
 * @description Retorna o arquivo PDF do boleto da parcela informada.
 * @summary Baixar PDF do boleto por parcela
 * {@link /api/v1/pecegepay/billet/:courseFinPersonPaymentId/pdf}
 */
export async function getApiV1PecegepayBilletCoursefinpersonpaymentidPdf(
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams["courseFinPersonPaymentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf401
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf404
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PecegepayBilletCoursefinpersonpaymentidPdfUrl(
      courseFinPersonPaymentId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
